import './Language.css'
const Language = (porps) => {
    return (
        <span className='language'>
            {porps.name}
        </span>
    )
}

export default Language